// extracted by mini-css-extract-plugin
export default {"noticeContainer":"NAtSk","newNotice":"_8UPQ2","noticeBody":"ihhmC","infoGroup":"MwsJt","userNickname":"_7-oua","commentDate":"UfgY5","loaderLine":"+Y6nC","full":"OAeUO"};